// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as API$LumiAuthentication from "./API.res.js";
import * as Form$LumiAuthentication from "./Form.res.js";
import * as I18n$LumiAuthentication from "./I18n.res.js";
import * as Modal$LumiAuthentication from "./Modal.res.js";
import * as Validate$LumiAuthentication from "./Validate.res.js";

function ChangePassword$Error(props) {
  return LumiReact.renderOption(undefined, props.error, err => JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("p", {
      children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
        entry: err
      })
    }),
    className: "notification is-danger"
  }));
}

let $$Error = {
  make: ChangePassword$Error
};

function ChangePassword$Success(props) {
  let dispatch = props.dispatch;
  return JsxRuntime.jsxs(Modal$LumiAuthentication.make, {
    title: "PhraseChangePassword",
    children: [
      JsxRuntime.jsx("section", {
        children: JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
            entry: "PhrasePasswordChanged"
          })
        }),
        className: "modal-card-body"
      }),
      JsxRuntime.jsx("footer", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
            children: JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                entry: {
                  TAG: "CommonEntry",
                  _0: "Close"
                }
              }),
              className: "button is-success",
              type: "button",
              onClick: param => dispatch("Close")
            }),
            className: "control"
          }),
          className: "field is-grouped is-grouped-right is-flex-1"
        }),
        className: "modal-card-foot"
      })
    ]
  });
}

let Success = {
  make: ChangePassword$Success
};

function ChangePassword(props) {
  let onClose = props.onClose;
  let match = LumiReactReducer.useReducer(() => ({
    TAG: "Init",
    _0: {
      oldPassword: "",
      newPassword: "",
      verifyPassword: "",
      error: undefined,
      success: false
    }
  }), undefined, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "Submit" :
          return {
            TAG: "Effect",
            _0: param => {
              let dispatch = param.dispatch;
              let match = param.state;
              return LumiRequest.resultFutureEffect(API$LumiAuthentication.accountChangePassword(match.oldPassword, match.newPassword), () => dispatch("HandleSuccess"), err => dispatch({
                TAG: "HandleError",
                _0: err
              }));
            }
          };
        case "HandleSuccess" :
          return {
            TAG: "Update",
            _0: {
              oldPassword: state.oldPassword,
              newPassword: state.newPassword,
              verifyPassword: state.verifyPassword,
              error: state.error,
              success: true
            }
          };
        case "Close" :
          return {
            TAG: "Effect",
            _0: param => {
              onClose();
            }
          };
      }
    } else {
      switch (action.TAG) {
        case "SetOldPassword" :
          return {
            TAG: "Update",
            _0: {
              oldPassword: action._0,
              newPassword: state.newPassword,
              verifyPassword: state.verifyPassword,
              error: state.error,
              success: state.success
            }
          };
        case "SetNewPassword" :
          return {
            TAG: "Update",
            _0: {
              oldPassword: state.oldPassword,
              newPassword: action._0,
              verifyPassword: state.verifyPassword,
              error: state.error,
              success: state.success
            }
          };
        case "SetVerifyPassword" :
          return {
            TAG: "Update",
            _0: {
              oldPassword: state.oldPassword,
              newPassword: state.newPassword,
              verifyPassword: action._0,
              error: state.error,
              success: state.success
            }
          };
        case "HandleError" :
          let err = action._0;
          console.error("accountChangePassword failed", err);
          return {
            TAG: "Update",
            _0: {
              oldPassword: state.oldPassword,
              newPassword: state.newPassword,
              verifyPassword: state.verifyPassword,
              error: I18n$LumiAuthentication.entryFromApiError(err),
              success: state.success
            }
          };
      }
    }
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let verifyPassword = match$1.verifyPassword;
  let newPassword = match$1.newPassword;
  let oldPassword = match$1.oldPassword;
  let oldPasswordValid = Validate$LumiAuthentication.existingPassword(oldPassword);
  let newPasswordValid = Validate$LumiAuthentication.newPassword(newPassword);
  let verifyPasswordValid = newPassword === verifyPassword;
  let valid = oldPasswordValid && newPasswordValid && verifyPasswordValid;
  if (match$1.success) {
    return JsxRuntime.jsx(ChangePassword$Success, {
      dispatch: dispatch
    });
  } else {
    return JsxRuntime.jsxs(Modal$LumiAuthentication.Form.make, {
      title: "PhraseChangePassword",
      onSubmit: param => dispatch("Submit"),
      children: [
        JsxRuntime.jsxs("section", {
          children: [
            JsxRuntime.jsx(ChangePassword$Error, {
              error: match$1.error
            }),
            JsxRuntime.jsx("p", {
              children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                entry: "PhraseEnterOldPassword"
              })
            }),
            JsxRuntime.jsx(Form$LumiAuthentication.ExistingPasswordField.make, {
              value: oldPassword,
              valid: oldPasswordValid,
              onChange: pass => dispatch({
                TAG: "SetOldPassword",
                _0: pass
              })
            }),
            JsxRuntime.jsx("p", {
              children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                entry: "PhraseEnterNewPassword"
              })
            }),
            JsxRuntime.jsx(Form$LumiAuthentication.NewPasswordField.make, {
              value: newPassword,
              valid: newPasswordValid,
              onChange: pass => dispatch({
                TAG: "SetNewPassword",
                _0: pass
              })
            }),
            JsxRuntime.jsx(Form$LumiAuthentication.VerifyPasswordField.make, {
              value: verifyPassword,
              valid: verifyPasswordValid,
              onChange: pass => dispatch({
                TAG: "SetVerifyPassword",
                _0: pass
              })
            })
          ],
          className: "modal-card-body"
        }),
        JsxRuntime.jsx("footer", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                    entry: {
                      TAG: "CommonEntry",
                      _0: "Close"
                    }
                  }),
                  className: "button",
                  type: "button",
                  onClick: param => dispatch("Close")
                }),
                className: "control"
              }),
              JsxRuntime.jsx("p", {
                children: JsxRuntime.jsx(Form$LumiAuthentication.Submit.make, {
                  classList: [
                    [
                      "button",
                      true
                    ],
                    [
                      "is-success",
                      true
                    ]
                  ],
                  enabled: valid,
                  label: "PhraseChangePassword"
                }),
                className: "control"
              })
            ],
            className: "field is-grouped is-grouped-right is-flex-1"
          }),
          className: "modal-card-foot"
        })
      ]
    });
  }
}

let T;

let make = ChangePassword;

export {
  T,
  $$Error,
  Success,
  make,
}
/* LumiReact Not a pure module */
